import SaveYourPay from 'features/accounts/SaveYourPay/SaveYourPay';
import React from 'react';

export default function Page() {
  return <SaveYourPay />;
}
